import {indicatorMetaBase} from '../config/environment';
import {fetchJson} from '../utils/fetch_utils';
import * as ActionTypes from './actionTypes';
import {error} from './index';

export const populateBurnPrescriptionsAsync = () => {
  const now = new Date().toISOString();

  return (dispatch) =>
    fetchJson(indicatorMetaBase + 'burnPrescriptions.json?time=' + now)
    .then(data => {
      // First populate the basic details of the Indicators
      dispatch(_populateBurnPrescriptions(data));
    })
    .catch(err => dispatch(error('Call to get Burn Prescription data failed: ' + (err.message || err))));
};

const _populateBurnPrescriptions = (data) => {
  return {
    type: ActionTypes.POPULATE_BURN_PRESCRIPTIONS,
    prescriptions: data
  };
};



// WEBPACK FOOTER //
// ./src/actions/populate_burn_prescriptions.js